import { Button, Collapse, message, Modal, Form, Select, Row } from "antd";
import React, { Component, Fragment } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import { connect } from "react-redux";
import { union } from "lodash";
import {
  HmgMainDropdown,
  HmgDropdown,
} from "../../components/HmgHotelDropdown/index";
import {
  QMS,
  ULP,
  Compliance,
  MyDocs,
  ULPConfigFilter,
  ComplianceConfigFilter,
  QMSConfigFilter,
  getULPDefaultConfigs,
  getComplianceDefaultConfigs,
  getQMSDefaultConfigs,
  getMyDocsDefaultConfigs,
  MyDocsConfigFilter,
  validateQMS,
  validateULP,
  validateCompliance,
} from "../../components/Project/AppConfiguration/index";
import {
  hmgmainGetHmgMain,
  projectGetAppConfiguration,
  applicationsGetAll,
  projectSetApplicationConfigurations,
} from "../../store/actions";
import moment from "moment";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const { confirm } = Modal;
const { Panel } = Collapse;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 18 },
  },
  style: { marginBottom: 8 },
};

const selectStyles = { maxWidth: 450 };

const getIndexList = (list) => list.map((el) => el.index_id);

export const ENABLED_APPS = ["ULP", "QMS", "myDocs", "Compliance"];

export const getDefaultConfigElement = (type) => {
  switch (type) {
    case "ULP":
      return { ...getULPDefaultConfigs };
    case "QMS":
      return { ...getQMSDefaultConfigs };
    case "Compliance":
      return { ...getComplianceDefaultConfigs };
    case "myDocs":
      return { ...getMyDocsDefaultConfigs };
    default:
      return {};
  }
};

export const getConfigs = (_id, allApps, configList) => {
  // const element = (this.state.projectData!==undefined && Array.isArray(this.state.projectData.applications)?this.state.projectData.applications:[]).find(el=>el.name===type)

  const element = allApps.find((el) => el._id === _id);

  if (element !== undefined) {
    const returnelm = configList.find((el) => el.app_id === element._id);
    return returnelm !== undefined
      ? returnelm
      : {
          app_id: element._id,
          config: {},
        };
  } else {
    return {
      app_id: undefined,
      config: {},
    };
  }
};
// export getConfigs;

export const preprocessRecord = (indexIds, app, configElm) => {
  switch (app.app_name) {
    case "myDocs":
      MyDocsConfigFilter(indexIds, configElm);
      break;
    case "ULP":
      ULPConfigFilter(indexIds, configElm);
      break;
    case "QMS":
      QMSConfigFilter(indexIds, configElm);
      break;
    case "Compliance":
      ComplianceConfigFilter(indexIds, configElm);
      break;
  }
};

const showConfirm = () => {
  return new Promise((resolve, reject) => {
    confirm({
      title: "Are you sure you want to enable ad hoc entries for PNA?",
      icon: null,
      // content: 'When clicked the OK button, this dialog will be closed after 1 second',
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      okText: "Yes",
      cancelText: "No",
    });
  });
};

class AppConfiguration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hmgmainSelect: undefined,
      hmgmainList: [],
      projectSelect: undefined,
      allApps: [],
      projectData: undefined,
      allocated_apps: [],
      configs: [],
      validate: {},
    };
  }

  componentDidMount = async () => {
    const result = await this.props.hmgmainGetHmgMain();
    const resultset2 = await this.props.applicationsGetAll();
    this.setState({
      hmgmainList: result,
      allApps: resultset2,
    });
  };

  hmgmainChange = (e) => {
    this.setState({
      projectSelect: undefined,
      hmgmainSelect: e,
      projectData: undefined,
      allocated_apps: [],
      configs: [],
    });
  };

  projectChange = async (e) => {
    const result = await this.props.projectGetAppConfiguration(e);

    const project = result.project;
    const allocated_apps =
      project !== undefined && Array.isArray(project.applications)
        ? project.applications.map((el) => el._id)
        : [];
    const project_configs =
      project !== undefined && Array.isArray(project.app_configurations)
        ? project.app_configurations
        : [];
    this.preprocessData(project_configs, project);
    console.log(result, "reslt data");
    // const allocated_apps = [];
    // const project_configs = []
    // console.log(result,'result')
    this.setState(
      {
        projectSelect: e,
        configs: this.generateDefaultConfigs(allocated_apps, project_configs),
        projectData: project,
        allocated_apps: allocated_apps,
      },
      () => {
        console.log(this.state, "state values");
      }
    );
  };

  getProjectList = (e) => {
    const hmgselected = this.state.hmgmainList.find((el) => el._id === e);
    if (hmgselected !== undefined) {
      return hmgselected.projects;
    }
    return [];
  };

  isConfigAvailable = (type) => {
    // const applist = (this.state.projectData!==undefined && Array.isArray(this.state.projectData.allocated_apps))?this.state.projectData.allocated_apps:[]
    // const availableOption
    // console.log(this.state.allocated_apps.find(el=>el.app_name===type)!==undefined,type,'is available')
    return (
      this.state.allocated_apps.find((el) => el.app_name === type) !== undefined
    );
  };

  preprocessData = (configset, project) => {
    const indexesset =
      project !== undefined ? getIndexList(project.indexes) : [];
    const indexIds = indexesset.map((el) => el._id);

    this.state.allApps.forEach((app) => {
      const configElm = configset.find((cl) => cl.app_id === app._id);
      if (configElm !== undefined && configElm.config !== undefined) {
        preprocessRecord(indexIds, app, configElm.config);
      }
    });

    // console.log(configset,'config set')
  };

  generateDefaultConfigs = (
    allocated_list = null,
    app_configurations = null
  ) => {
    let config_list = Array.isArray(app_configurations)
      ? [...app_configurations]
      : [...this.state.configs];

    const allocatedapp_list = Array.isArray(allocated_list)
      ? allocated_list
      : this.state.allocated_apps;
    let project_type = "";
    if (typeof this.state.projectData === "object") {
      project_type = this.state.projectData.solution;
    }

    allocatedapp_list.forEach((ap_id) => {
      const app = this.state.allApps.find((rl) => rl._id === ap_id);
      if (app !== undefined) {
        const configElement = config_list.find((cl) => cl.app_id === app._id);
        if (configElement === undefined) {
          config_list.push({
            app_id: app._id,
            config: getDefaultConfigElement(app.app_name),
          });
        }
      }
    });

    return [
      ...config_list.filter((el) => allocatedapp_list.includes(el.app_id)),
    ];

    // return (Array.isArray(this.state.projectData.applications)?this.state.projectData.applications:[]).map(el=>{
    //     return {
    //         app_id:el.app_id,
    //         config:getDefaultConfigElement(el.name)
    //     }
    // })
  };

  updateValue = async (value, _id, key1) => {
    // console.log(value,_id,key1)
    // const element = (Array.isArray(this.state.projectData.applications)?this.state.projectData.applications:[]).find(el=>el.name===type)
    const appElm = this.state.allApps.find((el) => el._id === _id);
    let project_type = "";
    if (typeof this.state.projectData === "object") {
      project_type = this.state.projectData.solution;
    }

    if (appElm !== undefined) {
      const configList = [...this.state.configs];
      // console.log(configList)
      const returnelm = configList.find((el) => el.app_id === _id);
      // console.log(returnelm,'return elm')

      if (returnelm !== undefined) {
        // if(key2===null){
        returnelm.config[key1] = value;
        if (
          appElm.app_name === "ULP" &&
          (key1 === "mandatory_indexes" || key1 === "searchable_indexes") &&
          Array.isArray(returnelm.config.required_indexes)
        ) {
          const validinds = union(
            returnelm.config.mandatory_indexes,
            returnelm.config.searchable_indexes
          );
          returnelm.config.required_indexes = [
            ...returnelm.config.required_indexes.filter((kl) => {
              return validinds.includes(kl);
            }),
          ];
        }
        if (
          appElm.app_name === "myDocs" &&
          key1 === "document_is_custom_inputs_allowed_reindex" &&
          project_type === "PNA"
        ) {
          if (returnelm.config[key1]) {
            const retval = await showConfirm();
            if (!retval) {
              returnelm.config[key1] = false;
            }
          }
        }
        if (
          appElm.app_name === "Compliance" &&
          key1 === "searchable_indexes" &&
          Array.isArray(returnelm.config.alternate_searchable_indexes)
        ) {
          const validinds = Array.isArray(returnelm.config.searchable_indexes)
            ? returnelm.config.searchable_indexes
            : [];
          returnelm.config.alternate_searchable_indexes = [
            ...returnelm.config.alternate_searchable_indexes.filter((kl) => {
              return !validinds.includes(kl);
            }),
          ];
        }
        returnelm.config = { ...returnelm.config };
        // }
        // else{
        //     const innerconfigset = {...returnelm.config[key1]}
        //     innerconfigset[key2]=value;
        //     returnelm.config[key1] = innerconfigset;
        //     returnelm.config = {...returnelm.config}
        // }
        // console.log(configList,'config list')
        this.setState({ configs: configList });
      }
    }
  };

  changeAllcatedApps = (e) => {
    this.setState({
      allocated_apps: e,
      configs: this.generateDefaultConfigs(e),
    });
  };

  renderConfigElement = (el) => {
    let retElm = null;
    if (!ENABLED_APPS.includes(el.app_name)) {
      return retElm;
    }
    // console.log(this.state.projectData,'project data')
    switch (el.app_name) {
      case "myDocs":
        retElm = (
          <MyDocs
            app_id={el._id}
            formItemLayout={formItemLayout}
            {...getConfigs(el._id, this.state.allApps, this.state.configs)}
            updateValue={this.updateValue}
            validate={this.state.validate}
          />
        );
        break;
      case "ULP":
        retElm = (
          <ULP
            app_id={el._id}
            indexes={
              this.state.projectData !== undefined
                ? getIndexList(this.state.projectData.indexes)
                : []
            }
            formItemLayout={formItemLayout}
            {...getConfigs(el._id, this.state.allApps, this.state.configs)}
            updateValue={this.updateValue}
            validate={this.state.validate}
          />
        );
        break;
      case "Compliance":
        retElm = (
          <Compliance
            app_id={el._id}
            indexes={
              this.state.projectData !== undefined
                ? getIndexList(this.state.projectData.indexes)
                : []
            }
            formItemLayout={formItemLayout}
            {...getConfigs(el._id, this.state.allApps, this.state.configs)}
            updateValue={this.updateValue}
            validate={this.state.validate}
          />
        );
        break;
      case "QMS":
        retElm = (
          <QMS
            app_id={el._id}
            indexes={
              this.state.projectData !== undefined
                ? getIndexList(this.state.projectData.indexes)
                : []
            }
            formItemLayout={formItemLayout}
            {...getConfigs(el._id, this.state.allApps, this.state.configs)}
            updateValue={this.updateValue}
            validate={this.state.validate}
          />
        );
        break;
    }

    return retElm !== null ? (
      <Collapse defaultActiveKey={el._id} expandIconPosition="end">
        <Panel header={`${el.app_name} Configurations`} key={el._id}>
          {retElm}
        </Panel>
      </Collapse>
    ) : null;
  };

  validateData = async () => {
    const validate = {};
    let returnval = true;
    this.state.allocated_apps.forEach((id) => {
      const element = this.state.allApps.find((el) => el._id === id);
      if (element !== undefined) {
        if (element.app_name === "QMS") {
          const appconfig = this.state.configs.find(
            (cl) => cl.app_id === element._id
          );
          if (appconfig !== undefined) {
            validateQMS(appconfig.config, validate);
          }
        } else if (element.app_name === "ULP") {
          const appconfig = this.state.configs.find(
            (cl) => cl.app_id === element._id
          );
          if (appconfig !== undefined) {
            validateULP(appconfig.config, validate);
          }
        } else if (element.app_name === "Compliance") {
          const appconfig = this.state.configs.find(
            (cl) => cl.app_id === element._id
          );
          if (appconfig !== undefined) {
            validateCompliance(appconfig.config, validate);
          }
        }
      }
    });

    Object.keys(validate).forEach((key) => {
      if (validate[key]) {
        returnval = false;
      }
    });
    if (!returnval) {
      message.error("Please fix all errors");
    }

    const updated = await new Promise((resolve) => {
      this.setState(
        {
          validate: validate,
        },
        () => {
          resolve(true);
        }
      );
    });
    return returnval;
  };

  submitData = async () => {
    const validateresult = await this.validateData();
    if (validateresult) {
      const result = await this.props.projectSetApplicationConfigurations({
        id: this.state.projectSelect,
        allocated_apps: this.state.allocated_apps,
        configs: this.state.configs,
      });
      await this.projectChange(this.state.projectSelect);
      // console.log(result,'result of the api submit')
    }
  };

  render() {
    return (
      <Fragment>
        <div className="container_aa">
          <h3>App Configurations</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "/app-configurations",
                breadcrumbName: "App Configurations",
              },
            ]}
          />
        </div>
        <div className="container_ab">
          <Collapse defaultActiveKey={[1, 2, 3, 4]} expandIconPosition="right">
            <Panel header="App Configurations" key="1">
              <Fragment>
                <HmgMainDropdown
                  hmgmainSelect={this.state.hmgmainSelect}
                  hmgmainList={this.state.hmgmainList}
                  hmgmainChange={this.hmgmainChange}
                />
                <HmgDropdown
                  hmgSelect={this.state.projectSelect}
                  handleHmgChange={this.projectChange}
                  loadHotelList={() => {}}
                  projectList={this.getProjectList(this.state.hmgmainSelect)}
                />
                {this.state.projectSelect !== undefined ? (
                  <Form.Item {...formItemLayout} label="Allocated Apps">
                    <Select
                      placeholder="Application"
                      value={this.state.allocated_apps}
                      showSearch={true}
                      filterOption={(input, option) => {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }}
                      mode="multiple"
                      style={selectStyles}
                      onChange={this.changeAllcatedApps}
                    >
                      {this.state.allApps.map((el) => {
                        return (
                          <Select.Option
                            value={el._id}
                            disabled={!ENABLED_APPS.includes(el.app_name)}
                            key={el._id}
                          >
                            {el.app_name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                ) : null}
              </Fragment>
            </Panel>
          </Collapse>
          {this.state.allocated_apps.map((id) => {
              const element = this.state.allApps.find((el) => el._id === id);
              if (element !== undefined) {
                return this.renderConfigElement(element);
              }
              return null;
            })}
          {this.state.hmgmainSelect !== undefined &&
          this.state.projectSelect !== undefined ? (
            <Row justify="center">
              <Button type="primary" onClick={this.submitData}>
                Update
              </Button>
            </Row>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  hmgmainGetHmgMain: () => dispatch(hmgmainGetHmgMain()),
  projectGetAppConfiguration: (id) => dispatch(projectGetAppConfiguration(id)),
  applicationsGetAll: () => dispatch(applicationsGetAll()),
  projectSetApplicationConfigurations: (props) =>
    dispatch(projectSetApplicationConfigurations(props)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppConfiguration);
